// extracted by mini-css-extract-plugin
module.exports = {"whiteBackground":"header_whiteBackground__VGRz2"};